import React, { memo, useMemo } from "react";
import { useSelector } from "react-redux";

import {
  getOperatorMissionOrder,
  getOperatorMissionStatus,
  getOperatorPanelOccupied,
} from "Slices/operatorData";

import { StyledVehicleOnWayProps } from "../../types";
import {
  StatusNameStyled,
  VehicleMissionBodyStyled,
  PlaceInQueueStyled,
  PlaceStyled,
} from "./styles";
import { getOrdinalSuffix } from "Utils";

type VehicleMissionStatusProps = {
  customStyles?: {
    StatusNameStyled?: typeof StatusNameStyled;
    VehicleMissionBodyStyled?: typeof VehicleMissionBodyStyled;
    PlaceInQueueStyled?: typeof PlaceInQueueStyled;
    PlaceStyled?: typeof PlaceStyled;
  };
};

export const VehicleMissionStatus = memo(
  (props: VehicleMissionStatusProps = {}) => {
    const { customStyles } = props;
    const operatorMissionStatus = useSelector(getOperatorMissionStatus);
    const operatorMissionOrder = useSelector(getOperatorMissionOrder);
    const operatorPanelOccupied = useSelector(getOperatorPanelOccupied);

    const vehiclePropsStyled: StyledVehicleOnWayProps = useMemo(() => {
      if (operatorPanelOccupied === false) {
        return {
          background: "#e9e9e9",
          message: "No Vehicles Called",
        };
      } else if (operatorMissionStatus === "IN_QUEUE") {
        return {
          background: "#e0c2a3",
          message: "Mission place in queue",
        };
      } else if (operatorMissionStatus === "IN_PROGRESS") {
        return {
          background: "#94d4e3",
          message: "Vehicle on its way!",
        };
      } else if (operatorMissionStatus === "NO_MISSION") {
        return {
          background: "#e9e9e9",
          message: "No Vehicles Called",
        };
      }
      return {
        background: "#e9e9e9",
        message: "Unsupported status",
      };
    }, [operatorMissionStatus, operatorPanelOccupied]);

    const { background, message } = vehiclePropsStyled;

    // Use custom styles if provided, otherwise use defaults
    const StatusName = customStyles?.StatusNameStyled || StatusNameStyled;
    const Body =
      customStyles?.VehicleMissionBodyStyled || VehicleMissionBodyStyled;
    const PlaceInQueue = customStyles?.PlaceInQueueStyled || PlaceInQueueStyled;
    const Place = customStyles?.PlaceStyled || PlaceStyled;

    return (
      <Body background={background}>
        <StatusName>{message}</StatusName>
        {operatorMissionStatus === "IN_QUEUE" &&
          Boolean(operatorMissionOrder) && (
            <PlaceInQueue>
              <Place>{operatorMissionOrder}</Place>
              {getOrdinalSuffix(operatorMissionOrder as number)}
            </PlaceInQueue>
          )}
      </Body>
    );
  }
);

VehicleMissionStatus.displayName = "VehicleMissionStatus";
